<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: 'Layout'
}
</script>



// WEBPACK FOOTER //
// src/components/layout.vue